<template>
    <span>{{ formatDateTime }}</span>
</template>

<script setup lang="ts">

import { computed, inject } from "vue";

const { dateTime, format = 'short' } = defineProps<{ dateTime: string, format: string }>()
const format_datetime = <(date: string, format: string) => string>inject("format_datetime");
const formatDateTime = computed(() => format_datetime(dateTime, format))

</script>

<style scoped>

</style>
